// TOP-LEVEL Inicializace Recombee

import * as Sentry from '@sentry/browser';
import * as RecombeeJSAPIClient from 'recombee-js-api-client';

import { RecombeeClient as recombeeClient } from '@components';
import { initBoxes } from './initBoxes';
import { recombeeAdvertAPI as addAdvertAPI } from './advertSupport';

interface RecombeeInitProps {
  articleId?: number;
  isArticle: boolean;
  isRecommId?: boolean;
  recommId?: string;
}

export const recombeeInit = (metaContent: string | null) => {
  if (!metaContent) return;

  // Načíst data z 'def-recombee-init.twig'
  const data: RecombeeInitProps | null = JSON.parse(metaContent) as RecombeeInitProps;
  const { articleId, isArticle, isRecommId, recommId } = data;

  // Načíst uživatele z Meiro COOKIE
  const userId: string | null = (document.cookie.match(
    /^(?:.*;)?\s*meiro_user_id\s*=\s*([^;]+)(?:.*)?$/
  ) || [null, null])[1];

  // Uložit do globálního scope
  window.CNC = window.CNC || {};
  window.CNC.recombee = {
    articleId,
    userId,
    client: recombeeClient,
  };

  // Tracker se inicializuje pouze pokud má uživatel nastaveno cookie _bisko
  if (userId && articleId && isArticle) {
    // Posílání PV detailu článku

    recombeeClient
      .send(
        isRecommId && recommId
          ? new RecombeeJSAPIClient.AddDetailView(userId, articleId, {
              recommId,
            })
          : new RecombeeJSAPIClient.AddDetailView(userId, articleId)
      )
      .catch((err) => {
        Sentry.captureException(err);
      });
  }

  // Konfigurovat nalezené boxy
  initBoxes();

  // Přidat podporu pro inzerci
  addAdvertAPI();
};

export default recombeeInit;
